import { formatDistanceToNow } from "date-fns";

export function FormatRelativeDate(prefix: string, date: Date | string | number): string {
  return (
    prefix +
    " " +
    formatDistanceToNow(date, {
      addSuffix: true,
    }).replace("about", "")
  );
}